import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ActiveCampaignsGrid = ({ campaigns }) => {
  const navigate = useNavigate();

  const getCategoryIcon = (category) => {
    const icons = {
      Fashion: 'Shirt',
      Electronics: 'Smartphone',
      Beauty: 'Sparkles',
      Fitness: 'Dumbbell',
      Food: 'UtensilsCrossed',
      Travel: 'Plane',
      Home: 'Home',
      Gaming: 'Gamepad2'
    };
    return icons?.[category] || 'Tag';
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 border border-border">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground mb-1">Active Campaigns</h2>
          <p className="text-sm text-muted-foreground">Available brand partnerships</p>
        </div>
        <div className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 rounded-lg">
          <Icon name="Zap" size={16} color="var(--color-primary)" />
          <span className="text-sm font-medium text-primary">{campaigns?.length} Active</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {campaigns?.map((campaign) => (
          <div
            key={campaign?.id}
            className="bg-muted/50 rounded-xl p-4 md:p-5 border border-border hover:border-primary/50 transition-all duration-250 hover:shadow-lg group"
          >
            <div className="flex items-start gap-3 mb-4">
              <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0 bg-background">
                <Image
                  src={campaign?.brandLogo}
                  alt={campaign?.brandLogoAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base md:text-lg font-semibold text-foreground mb-1 line-clamp-1">
                  {campaign?.brandName}
                </h3>
                <div className="flex items-center gap-2">
                  <Icon name={getCategoryIcon(campaign?.category)} size={14} color="var(--color-muted-foreground)" />
                  <span className="text-xs text-muted-foreground">{campaign?.category}</span>
                </div>
              </div>
            </div>

            <div className="space-y-3 mb-4">
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Cashback Rate</span>
                <span className="text-lg font-bold text-primary">{campaign?.cashbackPercentage}%</span>
              </div>
              
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Reward Cap</span>
                <span className="text-sm font-semibold text-foreground">${campaign?.rewardCap}</span>
              </div>

              <div className="pt-3 border-t border-border">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Users" size={14} color="var(--color-muted-foreground)" />
                  <span className="text-xs text-muted-foreground">Min. {campaign?.minFollowers?.toLocaleString()} followers</span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="Calendar" size={14} color="var(--color-muted-foreground)" />
                  <span className="text-xs text-muted-foreground">Ends {campaign?.endDate}</span>
                </div>
              </div>
            </div>

            <Button
              variant="default"
              onClick={() => navigate('/transaction-submission-screen')}
              iconName="ArrowRight"
              iconPosition="right"
              fullWidth
              className="group-hover:shadow-md"
            >
              Participate
            </Button>
          </div>
        ))}
      </div>
      {campaigns?.length === 0 && (
        <div className="text-center py-12">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
            <Icon name="Inbox" size={32} color="var(--color-muted-foreground)" />
          </div>
          <p className="text-muted-foreground mb-4">No active campaigns available</p>
          <Button variant="outline" onClick={() => navigate('/user-dashboard')}>
            Refresh
          </Button>
        </div>
      )}
    </div>
  );
};

export default ActiveCampaignsGrid;